




















import { Prop, Component, Vue } from 'vue-property-decorator'
import { Marked, escape, Renderer } from 'marked-ts'
import { GithubIssue } from '@/@types/Github'
import ExternalLinkIcon from '@/components/ExternalLinkIcon.vue'
import { getContrastYIQ } from '@/utils/color.ts'
Marked.setOptions({
  renderer: new Renderer(),
  gfm: true,
  tables: true,
  breaks: false,
  pedantic: false,
  sanitize: false,
  smartLists: true,
  smartypants: false
})

@Component({
  components: {
    ExternalLinkIcon
  }
})

export default class Issues extends Vue {
  @Prop()
  data!: GithubIssue

  open = false

  public get repoName (): string {
    const match = this.data.repository_url.match(/repos\/(.*)$/)
    if (match?.length) {
      return match[1]
    }
    return ''
  }

  public renderMD (markdown: string): string {
    return Marked.parse(escape(markdown))
  }

  public showToggle (): void {
    this.open = !this.open
  }

  public getLabelStyle (color: string): {backgroundColor: string; color: string} {
    return {
      backgroundColor: `#${color}`,
      color: getContrastYIQ(color)
    }
  }
}
